<samweb-toolbar [brickInstanceId]="brickInstanceId" [toolbarId]="'toolbar'" [smallView]="true"></samweb-toolbar>
